// Auth interceptor — attaches JWT token to requests and handles 401 refresh
// This is a placeholder — will be integrated with the api-client in production

export function attachAuthToken(headers: Record<string, string>): Record<string, string> {
  if (typeof window === 'undefined') return headers;

  const token = localStorage.getItem('access_token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

export async function handleUnauthorized(): Promise<boolean> {
  // Attempt token refresh
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken) return false;

  try {
    // Placeholder — will call /auth/refresh endpoint
    console.log('[Auth] Would attempt token refresh');
    return false;
  } catch {
    // Refresh failed — clear session
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/auth/login';
    return false;
  }
}
